import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("UserManagementPermissions")
export class UserManagementPermissions {
    static readonly None = 0;
    static readonly Invite = 1;
    static readonly Edit = 2;
    static readonly Delete = 4;
}
